var map = {
	"./appAsset-brand--axteroid-icon-test-dark.svg": "7df8",
	"./appAsset-brand--axteroid-icon-test.svg": "5afc",
	"./appAsset-brand--axteroid-icon.svg": "049a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c488";